/* eslint-disable no-nested-ternary */
import React, { Component } from "react";
import PropTypes from "prop-types";

let historyData = null;

export default class ServiceHistory extends Component {
  abortController = new AbortController();

  monthList = [
    "",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  constructor(props, context) {
    super(props, context);
    this.state = {
      loadState: "initial",
      fileDate: "",
    };
  }

  componentDidMount = () => {
    if (historyData === null) {
      this.setState({ loadState: "loading" }, () => {
        fetch(`/getToken`, {
          signal: this.abortController.signal,
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error("Network response was not ok");
            }
            return res.json();
          })
          .then((resp) => {
            const authData = resp.response;
            fetch(
              `/nm-api/api/services/${this.props.moduleGroupId}/history?tzclient=${document.getElementById("react_currentAccountId").value}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authData.jwt}`,
                },
                signal: this.abortController.signal,
              },
            )
              .then((res) => {
                if (!res.ok) {
                  throw new Error("Network response was not ok");
                }
                return res.json();
              })
              .then((responseObj) => {
                if (responseObj.status === "success") {
                  historyData = responseObj.data;
                  this.setState({ loadState: "loaded" });
                } else {
                  this.setState({ loadState: "error" });
                }
              })
              .catch((error) => {
                console.error("Error:", error);
                this.setState({ loadState: "error" });
              });
          });
      });
    }
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  formatInitialDate = (dateString) => {
    const hour = Number(dateString.substring(9, 11));
    return (
      <span>
        <strong>
          {dateString.substring(0, 2)}{" "}
          {this.monthList[Number(dateString.substring(3, 5))]} 20
          {dateString.substring(6, 8)}
        </strong>{" "}
        at{" "}
        <strong>
          {hour > 21
            ? hour - 12
            : hour > 12
              ? `0${hour - 12}`
              : dateString.substring(9, 11)}
          :{dateString.substring(12, 14)}{" "}
          {Number(dateString.substring(9, 11)) > 11 ? "PM" : "AM"}
        </strong>
      </span>
    );
  };

  initialHistory = () => {
    return (
      <span>
        {this.props.modified !== this.props.created && (
          <div className="label-right">
            <span>UNKNOWN SERVICE NAME</span>

            <div>
              <span>Edited by {this.props.modifiedBy}</span>
              <span>{this.formatInitialDate(this.props.modified)}</span>
            </div>
          </div>
        )}
        <div className="label-right">
          <span>UNKNOWN SERVICE NAME</span>

          <div>
            <span>Created by {this.props.createdBy}</span>
            <span>{this.formatInitialDate(this.props.created)}</span>
          </div>
        </div>
      </span>
    );
  };

  formatHistoryDate = (timeStamp) => {
    return (
      <span>
        <strong>{timeStamp.split(" ~ ")[0]}</strong> at{" "}
        <strong>{timeStamp.split(" ~ ")[1]}</strong>
      </span>
    );
  };

  restoreService = (fileDate) => {
    this.setState({ fileDate });
    window.top.fileDate = fileDate;
    // eslint-disable-next-line no-undef
    EnterpriseService.reload();
  };

  displayServiceHistory = () => {
    if (historyData.length > 0) {
      let firstEntry = true;
      let hasCreated = false;
      const returnValue = historyData
        .sort((a, b) => b.id - a.id)
        .map((entry, idx) => {
          const jsonData = JSON.parse(entry.json_data);
          let buttonLabel = "";
          if (jsonData.action !== "update") {
            hasCreated = true;
          }
          let label = "Edited";
          if (jsonData.action !== "update") {
            label = "Created";
          }
          if (firstEntry) {
            buttonLabel = "LIVE VERSION";
            firstEntry = false;
          }
          return (
            <div className="label-right" key={idx}>
              <span>
                {entry.service_name || "UNKNOWN SERVICE NAME"}
                <br />
                {label} by {entry.displayName}
                <br />
                {this.formatHistoryDate(entry.timeStampString)}
              </span>

              <div>
                {
                  <a
                    className="button"
                    style={{
                      display: "block",
                      textAlign: "center",
                      marginRight: "5px",
                    }}
                    onClick={() => this.restoreService(jsonData.fileDate)}
                  >
                    {buttonLabel ||
                      (jsonData.fileDate === this.state.fileDate
                        ? "Viewing"
                        : "Restore")}
                  </a>
                }
              </div>
            </div>
          );
        });
      if (!hasCreated) {
        returnValue.push(
          <div className="label-right" key="createdKey">
            <span>UNKNOWN SERVICE NAME</span>
            <span>Created by {this.props.createdBy}</span>
            <span>{this.formatInitialDate(this.props.created)}</span>
          </div>,
        );
      }
      return returnValue;
    }

    return this.initialHistory();
  };

  render = () => {
    const centreStyle = { textAlign: "center" };
    switch (this.state.loadState) {
      case "initial":
        return <div className="label-right"></div>;
      case "loading":
        return (
          <div>
            <div style={centreStyle}>
              <img src={"/_client/images/global/ui-loader-1.gif"} />
            </div>
          </div>
        );
      case "error":
        return (
          <div className="label-right">
            <span>Error</span>
            <div>
              <span>Unable to load service history</span>
            </div>
          </div>
        );
      case "loaded":
        return this.displayServiceHistory();
      default:
        return <div></div>;
    }
  };
}

ServiceHistory.propTypes = {
  moduleGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modified: PropTypes.object,
  created: PropTypes.object,
  modifiedBy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  createdBy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
